module.exports = __webpack_public_path__ + "img/jidian_liucheng.b916ecfe.png";